import { InjectionToken } from '@angular/core';

export type WebComponentRootElementGetter = () => HTMLElement | undefined;
export type FontsToLoad = {
	family: string;
	fileName: string;
	descriptors?: FontFaceDescriptors;
}[];

export const WINDOW = new InjectionToken('window', { providedIn: 'root', factory: () => window });

export const WEBCOMPONENT_ROOT_ELEMENT_GETTER = new InjectionToken<WebComponentRootElementGetter>('WebComponentRootElementGetter');
export const STATIC_FILES_ENDPOINT = new InjectionToken<string>('StaticFilesEndpoint');
export const FONTS_TO_LOAD = new InjectionToken<FontsToLoad>('FontsToLoad');
